import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { AgGridReact } from 'ag-grid-react';
import { useDispatch, useSelector } from 'react-redux';
import useDeepCompareEffect from 'use-deep-compare-effect';
import DetailsCount from './details-count';
import { triggerRowHighlight } from '../../worklist/containers/worklist-actions';

const PlanningCellRenderer = ({ detailGridOptions, data }) => {
  const gridRef = useRef();
  const dispatch = useDispatch();
  const [options, setOptions] = useState(detailGridOptions);
  const [prevUpdatedRowsData, setPrevUpdatedRowsData] = useState([]);
  const childColumnDetails = useSelector(state =>
    state.worklist.childColumnDetails || [],
  );
  const {
    childSelection,
    updatedRowsData,
    rowHighlightTrigger,
  } = useSelector(state => state.worklist);

  useDeepCompareEffect(() => {
    setOptions({
      ...detailGridOptions,
      columnDefs: childColumnDetails,
    });
  }, [childColumnDetails]);

  useDeepCompareEffect(() => {
    if (updatedRowsData.length || rowHighlightTrigger) {
      if (rowHighlightTrigger) {
        dispatch(triggerRowHighlight(false));
      }
      updatedRowsData.forEach((d) => {
        d.children.forEach((c) => {
          const childNode = gridRef.current?.api?.getRowNode(c.id);
          if (childNode) {
            // No need to  set highlighted since it is handled by rowClassRules
            // Since we don't update data, we  need to redrawrows manually
            gridRef?.current?.api?.redrawRows({ rowNodes: [childNode] });
          }
        });
      });
    } else {
      prevUpdatedRowsData.forEach((d) => {
        d.children.forEach((c) => {
          const childNode = gridRef.current?.api?.getRowNode(c.id);
          if (childNode) {
            childNode.data.highlighted = null;
            gridRef?.current?.api?.redrawRows({ rowNodes: [childNode] });
          }
        });
      });
    }
    setPrevUpdatedRowsData(updatedRowsData);
  }, [updatedRowsData, rowHighlightTrigger]);

  // when you close and open the master, you destroy the childeren rows
  // if you select them and you open and close them, this selection will be forgotten
  // isDefaultSelected will select the ones that you selected => and is saved in the state
  const isDefaultSelected = ({ api }) => {
    api.forEachNode((n) => {
      n.setSelected(!!childSelection?.find(item => item?.id === n?.data?.id));
    });
  };

  return <>
    <DetailsCount count={data?.children?.length} total={data?.totalChildrenCount} />
    <AgGridReact
      {...options}
      ref={gridRef}
      rowData={data.children}
      className='ag-details-grid'
      onGridReady={e => isDefaultSelected(e)}
      rowClassRules={{
        highlighted: params =>
          updatedRowsData?.find(r => r.id === data.id) &&
          params.data?.highlighted,
      }}
    />
  </>;
};
PlanningCellRenderer.propTypes = {
  detailGridOptions: PropTypes.object,
  data: PropTypes.object,
};

export default PlanningCellRenderer;
